export const usePrices = () => useFetch("/api/prices", { key: "prices" });
